export default __webpack_public_path__ + "static/media/ChallPacoOpenlyES@2x.ddefddab.png";